import Rails from '@rails/ujs'
import { wemeikPopup } from './vue/core'
const firebase = require('firebase/app')
require('firebase/firebase-messaging')

const notSupported = function () {
  console.log('Not supported')
}

let requestPermission = notSupported
let reviewForExistingFcmToken = notSupported

try {
  // Your web app's Firebase configuration
  firebase.initializeApp({
    apiKey: 'AIzaSyDSlQgZRWYWRV5nOTu-27pj1N8PcpZleHs',
    authDomain: 'uorder-253820.firebaseapp.com',
    databaseURL: 'https://uorder-253820.firebaseio.com',
    projectId: 'uorder-253820',
    storageBucket: 'uorder-253820.appspot.com',
    messagingSenderId: '52801919270',
    appId: '1:52801919270:web:e6d1eec323402b68eb89e7',
    measurementId: 'G-J1JT5R1E9L'
  })

  const messaging = firebase.messaging()

  const registerToken = function (token) {
    Rails.ajax({
      url: '/fcm_tokens',
      type: 'POST',
      dataType: 'json',
      data: `fcm_token[token]=${token}`,
      success: () => { },
      error: () => { }
    })
  }

  requestPermission = function (callback) {
    wemeikPopup({
      title: 'Activa las notificaciones',
      text: 'Por favor, activa las notificaciones para enterarte lo que ocurre con tu pedido.',
      icon: 'info',
      dangerMode: false,
      buttons: {
        cancel: 'Ahora no',
        confirm: 'Activar'
      }
    })
      .then((willAccept) => {
        if (willAccept) {
          messaging.requestPermission()
            .then(() => {
              return messaging.getToken()
            })
            .then((token) => {
              callback(token)
            })
            .catch((error) => {
              console.error('Error requesting permission ', error)
            })
        } else {
          sessionStorage.setItem('_w_daban', true)
        }
      })
  }

  reviewForExistingFcmToken = function () {
    if (sessionStorage.getItem('_w_daban') !== 'true') {
      if (Notification.permission !== 'granted') {
        requestPermission(registerToken)
      } else if (Notification.permission !== 'denied') {
        messaging.getToken().then((currentToken) => {
          if (currentToken) {
            registerToken(currentToken)
          } else {
            requestPermission(registerToken)
            // Show permission request.
            // console.log('No Instance ID token available. Request permission to generate one.')
          }
        }).catch((error) => {
          console.error('An error occurred while retrieving token. ', error)
        })
      }
    }
  }
} catch (error) {
  console.error(error)
}

export { requestPermission, reviewForExistingFcmToken }
